import axios from 'axios';
import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  /**
   * Applies one conversation-visibility value to several agents in a single request.
   *
   * One call rather than a PATCH per agent, because a partial failure halfway through a
   * multi-selection leaves the list showing a state the administrator never chose. The server
   * wraps the whole set in a transaction and replies with the updated agents.
   */
  bulkUpdateVisibility({ agentIds, conversationVisibility }) {
    return axios.patch(`${this.url}/bulk_update`, {
      agent_ids: agentIds,
      conversation_visibility: conversationVisibility,
    });
  }
}

export default new Agents();
